import {
  GET_ALL_REPORTS,
  GET_REPORT_EXCEL,
  DELETE_ALL_REPORTS,
  GET_ALL_ACTIVITIES,
  GET_ALL_MATERIALS,
  FINISH_LOADED_NEW_DATA_ON_WORKTIME_PAGE
} from '../../actions/reports';


// in future we can add initial state and explain each parameter
const initialState = {
  list: null,
  exel: null,
  activities: {},
  loadedNewData: false
}

export default function reports(state = {}, action) {
  switch(action.type) {
    case GET_ALL_REPORTS:
      return Object.assign({}, state, action.payload);
    case DELETE_ALL_REPORTS:
      state.list = {};
      return Object.assign({}, state, action.payload);
    case GET_REPORT_EXCEL:
      return Object.assign({}, state, action.payload);
    case GET_ALL_ACTIVITIES:
      return Object.assign({}, state, action.payload);
    case GET_ALL_MATERIALS:
      return Object.assign({}, state, action.payload);
    case FINISH_LOADED_NEW_DATA_ON_WORKTIME_PAGE:
      return Object.assign({}, state, {loadedNewData: action.payload});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reports/index.js